import { PulseFilters, pulseFiltersSchema } from './types'

import { api } from 'api'
import { z } from 'zod'

const ratingMetricsResponse = z.array(
  z.object({
    shift_date: z.string(),
    avg_worker_rating_by_manager: z.number(),
    avg_shift_rating_by_worker: z.number(),
    count_shift_rating_by_worker: z.number(),
    count_worker_rating_by_manager: z.number(),
    number_managers_rated_worker_below_3: z.number(),
    number_workers_rated_shift_below_3: z.number(),
  })
)

export type RatingMetrics = z.infer<typeof ratingMetricsResponse>

export async function getRatingMetrics(
  filters: PulseFilters,
  signal?: AbortSignal
) {
  const data = pulseFiltersSchema.parse(filters)
  return api
    .post('/company/pulse/performance/rating_metrics', data, { signal })
    .then((res) => res.data.metrics)
}
